import styled from "styled-components";
const images = require.context("../../assets/img", true);
const Wrapper = styled.img`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  display: flex;
  align-items: center;
`;
const Empty = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  width?: number | string;
  height?: number | string;
  token?: string;
  secondary?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  style?: {};
};

//{width,height,token,secondary,className,onClick,style = {},...rest}
export default function Icon(props: Props) {
  const { width, height, token, secondary, className, onClick, style } = props;
  let img: any;
  try {
    img = images(`./${token}.svg`);
  } catch (e) {
    try {
      img = images(`./${secondary}.svg`);
    } catch (e) {}
  }
  return img ? (
    <Wrapper
      src={img}
      width={width}
      height={height}
      style={{ ...style }}
      className={className}
      onClick={onClick}
    />
  ) : (
    <Empty className={className}></Empty>
  );
}
